import { IconProps } from 'types/icon.type'

export const ShippingIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Shipping icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.55546 4.05546C3.07118 3.53973 3.77065 3.25 4.5 3.25H12.5C13.2293 3.25 13.9288 3.53973 14.4445 4.05546C14.9603 4.57118 15.25 5.27065 15.25 6V7.25H18.0211C18.2834 7.25037 18.5422 7.3097 18.7785 7.4236C19.0148 7.53749 19.2224 7.70304 19.3861 7.908L22.865 12.2567C23.1135 12.5664 23.2493 12.9515 23.25 13.3487L23.25 13.35L23.25 17C23.25 17.4641 23.0656 17.9092 22.7374 18.2374C22.4092 18.5656 21.9641 18.75 21.5 18.75H19.5C19.0858 18.75 18.75 18.4142 18.75 18C18.75 17.5858 19.0858 17.25 19.5 17.25H21.5C21.5663 17.25 21.6299 17.2237 21.6768 17.1768C21.7237 17.1299 21.75 17.0663 21.75 17L21.75 13.3513C21.75 13.3511 21.75 13.3515 21.75 13.3513C21.7498 13.2948 21.7304 13.2394 21.695 13.1953L18.2143 8.84452C18.191 8.81524 18.1609 8.79107 18.1271 8.7748C18.0935 8.75859 18.0567 8.75012 18.0194 8.75H15.25V17.25H15.5C15.9142 17.25 16.25 17.5858 16.25 18C16.25 18.4142 15.9142 18.75 15.5 18.75H9.5C9.08579 18.75 8.75 18.4142 8.75 18C8.75 17.5858 9.08579 17.25 9.5 17.25H13.75V6C13.75 5.66848 13.6183 5.35054 13.3839 5.11612C13.1495 4.8817 12.8315 4.75 12.5 4.75H4.5C4.16848 4.75 3.85054 4.8817 3.61612 5.11612C3.3817 5.35054 3.25 5.66848 3.25 6V17C3.25 17.0663 3.27634 17.1299 3.32322 17.1768C3.37011 17.2237 3.43369 17.25 3.5 17.25H5.5C5.91421 17.25 6.25 17.5858 6.25 18C6.25 18.4142 5.91421 18.75 5.5 18.75H3.5C3.03587 18.75 2.59075 18.5656 2.26256 18.2374C1.93437 17.9092 1.75 17.4641 1.75 17V6C1.75 5.27065 2.03973 4.57118 2.55546 4.05546Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 16.75C16.8096 16.75 16.25 17.3096 16.25 18C16.25 18.6904 16.8096 19.25 17.5 19.25C18.1904 19.25 18.75 18.6904 18.75 18C18.75 17.3096 18.1904 16.75 17.5 16.75ZM14.75 18C14.75 16.4812 15.9812 15.25 17.5 15.25C19.0188 15.25 20.25 16.4812 20.25 18C20.25 19.5188 19.0188 20.75 17.5 20.75C15.9812 20.75 14.75 19.5188 14.75 18Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 16.75C6.80964 16.75 6.25 17.3096 6.25 18C6.25 18.6904 6.80964 19.25 7.5 19.25C8.19036 19.25 8.75 18.6904 8.75 18C8.75 17.3096 8.19036 16.75 7.5 16.75ZM4.75 18C4.75 16.4812 5.98122 15.25 7.5 15.25C9.01878 15.25 10.25 16.4812 10.25 18C10.25 19.5188 9.01878 20.75 7.5 20.75C5.98122 20.75 4.75 19.5188 4.75 18Z"
        fill="currentColor"
      />
    </svg>
  )
}
